﻿const regionFilter = document.getElementById("region-filter")
const occupationFilter = document.getElementById("occupation-filter")
const url = new URL(window.location.href);

if (regionFilter != null) {
	regionFilter.addEventListener("change", e => {
		url.searchParams.set("page", 0)
		url.searchParams.set("region", e.target.value)
		window.location = url.toString()
	})
}

if (occupationFilter !== null) {
	occupationFilter.addEventListener("change", e => {
		url.searchParams.set("page", 0)
		url.searchParams.set("occupation", e.target.value)
		window.location = url.toString()
	})
}

const fetchButton = document.getElementById("fetch-ads-button")

if (fetchButton != null) {
	fetchButton.addEventListener("click", async () => {
		const data = fetchButton.dataset
		const expired = data.expired == "true"
		const adsList = document.querySelector(".ads__list")
		const adsListCount = adsList.querySelectorAll("li")?.length
		const page = Math.floor(adsListCount / data.limit)
		const type = expired ? "Expired" : "Current"
		const response = await fetch(`/Umbraco/Api/JobAds/${type}?page=${page}&limit=${data.limit}&region=${data.region}&occupation=${data.occupation}`)
		const ads = await response?.json()
		const expiredClass = expired ? " expired" : "";
		for (const ad of ads?.jobAds) {
			const li = document.createElement("li")
				li.innerHTML = `
                <div class="company-logo"><img src="${ad.companyUrl}" alt="${ad.company}" /></div>
                <div class="details">
                    <div class="title">
                            <a href="${ad.navigateUrl}" title="${ad.title}" class="${expiredClass}">
                            ${ad.title}
                        </a>
                    </div>
                    <div class="bottom">
                        <div class="company-name">${ad.company}</div>
                        <div class="region">${ad.region}</div>
                        <div class="apply-stop"><span class="label">Ansök senast:</span>${ad.endDate}</div>
                    </div>
                </div>
                ${expired ? "" : `
					<div class="button_wrapper">
						<span class="button">Sök jobbet</span>
					</div>
				`}
			`
			adsList.append(li)
		}
		if (adsListCount === ads?.total || adsListCount < data.limit) {
			fetchButton.style.display = 'none';
		}
		else {
			delete fetchButton.style.display;
		}
	})
}
